<svg width="100%" height="100%" >
  <g *ngFor="let bar of bars">
    <g style="opacity: 1;">
      <text class="cp-font-white cp-font-bold" dy=".71em" [attr.y]="bar.topY" [attr.x]="bar.topX" fill="#FFFFFF"
        style="text-anchor: middle;">{{bar.topText}}</text>
    </g>

    <g transform="translate(0,8)">
      <rect class="barra" [attr.x]="bar.barX" [attr.width]="bar.barWidth" [attr.y]="bar.barY" [attr.height]="bar.barHeigth"
        style="fill:#FFFFFF;stroke-width:0;stroke:#FFFFFF;opacity:1;"></rect>
    </g>

    <g style="opacity: 1;">
      <text class="cp-font-white cp-font-bold" dy=".71em" [attr.y]="bar.bottomY" [attr.x]="bar.bottomX" fill="#FFFFFF"
        style="text-anchor: middle;">{{bar.bottomText}}</text>
    </g>
  </g>
</svg>
